module.exports = "<figure class=\"limitContent\" ng-repeat=\"paragraph in $ctrl.paragraphs\">\n  <img ng-class-odd=\"'floatedLeft'\" ng-class-even=\"'floatedRight'\" class=\"sizeAjust tab desk\" ng-src=\"img/photos/{{paragraph}}.jpg\" width=\"400\" height=\"225\" alt=\"photo à décrire\">\n  <figcaption>\n    <p ng-class=\"{'arabDirectionDesc':  $ctrl.I18n.isArLocale()}\">\n      {{ 'home.description.' + paragraph | translate }}\n    </p>\n  </figcaption>\n</figure>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/description/home-description.html
// module id = 786
// module chunks = 0